import Element from '../ui/Element';
import ClickableMixin from './mixins/ClickableMixin';
import mixin from '../privates/utils/mixin';
import ContainableMixin from './mixins/ContainableMixin';
import StyleMixin from './mixins/styleMixins/StyleMixin';

/**
 * @class Footer
 * @summary The footer is the area of your site that appears at the bottom and
 *  throughout all of your pages.
 * @classdesc The footer is located at the bottom of the page:
 * 
 *  ![Wix Page Footer](images/footer.png "Wix Page Footer")
 * 
 *  The footer is a container that can contain other elements.
 *
 *  The contained elements are the footer's [children](#children) and the
 *  footer is the contained elements' [parent](#parent).
 *
 *  The same footer appears on all pages of your site. Therefore, the children
 *  elements of a footer appear on all pages of your site.
 * 
 *  The `Footer` is part of the [`Document`]($w.Document.html). 
 * @see [Header]($w.Header.html)
 * @see [Document]($w.Document.html)
 * @mixes $w.Element
 * @mixes $w.ClickableMixin
 * @mixes $w.ContainableMixin
 * @mixes $w.StyleMixin
 * @memberof $w
 * @queryable
 * @viewername wysiwyg.viewer.components.FooterContainer
 * @definitionId wysiwyg.viewer.components.FooterContainer
 * @tagname footer
 */
class Footer extends Element {

}

/**
 * @member style
 * @label property
 * @syntax
 * get style(): Style
 * @summary Gets an object containing information about the footer's styles.
 * @description
 *  The following styles can be used with footers:
 *
 *  + [`backgroundColor`]($w.Style.html#backgroundColor)
 *  + [`borderColor`]($w.Style.html#borderColor)
 * @snippet [BackgroundColorMixin-backgroundColor_set.es6=Set the background color]
 * @snippet [BackgroundColorMixin-backgroundColor_get.es6=Get the background color]
 * @type {$w.Style}
 * @memberof $w.Footer
 * @readonly
 * @override
 */

mixin(Footer.prototype, ClickableMixin.prototype);
mixin(Footer.prototype, ContainableMixin.prototype);
mixin(Footer.prototype, StyleMixin.prototype);

export default Footer;
